// Polyfill process for Firebase SDK compatibility in browsers
interface ProcessPolyfill {
    env: Record<string, unknown>
    emit: () => void
    on: () => void
    cwd: () => string
    nextTick: (fn: () => void) => void
}

declare global {
    var process: ProcessPolyfill | undefined
}

if (typeof process === 'undefined') {
    globalThis.process = {
        env: {},
        emit: () => {},
        on: () => {},
        cwd: () => '/',
        nextTick: (fn: () => void) => setTimeout(fn, 0),
    }
}

import './widget'
